<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="change(localeObj)"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BImg } from 'bootstrap-vue'

export default {
  components: {
    BNavItemDropdown,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      localStorage.setItem('CurrentLocal', this.$i18n.locale)
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
  },
  methods: {
    change(localeObj) {
      this.$i18n.locale = localeObj.locale
      window.location.reload()
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: '0',
        img: require('@/assets/images/flags/fa.png'),
        name: 'فارسی',
      },
      {
        locale: '1',
        img: require('@/assets/images/flags/en.png'),
        name: 'انگلیسی',
      },
      {
        locale: '2',
        img: require('@/assets/images/flags/ar.png'),
        name: 'عربی',
      },
    ]
    /* eslint-disable global-require */

    return {
      locales,
    }
  },
}
</script>

<style>

</style>
